import { PhoneMenuItems } from '../../models/Phone';
import { PhonePhoneLayout } from '../PhonePhone/PhonePhone';

const PhoneContacts = () => {
	return <PhonePhoneLayout initialMenuItem={PhoneMenuItems.CONTACTS} />;
};

export { PhoneContacts };
